import { searchInputStyles } from "@insite/content-library/Widgets/Header/SearchInput";
import { css } from "styled-components";

searchInputStyles.autocompleteColumnWrapper = {
    css: css`
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 0 20px 15px 20px;
`,
};
